export default __webpack_public_path__ + "static/media/telegram.28141391.svg";